export default "__VITE_ASSET__CkEEcC$j__"